import React from 'react';
import { SectionHeading } from './SectionHeading';
import { skills } from '../data/expertise';
export function ExpertiseTags() {
  return <section id="expertise" className="scroll-mt-16 bg-white" data-id="element-113" data-mp="30s76oaoa0jld">
      <div className="mx-auto max-w-shell px-6 py-20 lg:px-10 lg:py-28" data-id="element-114" data-mp="3fo6jfymbz7wu">
        <div className="grid gap-12 lg:grid-cols-[1fr_1.4fr] lg:gap-20" data-id="element-115" data-mp="3aotqcw4v94lt">
          <SectionHeading index="V" title="Core Skills & Board Affiliations" description="Board-level competencies applied across regulated healthcare, aviation, and public-sector capital programs." data-id="element-116" data-mp="3aqwok3g6a41m" />

          <div data-id="element-117" data-mp="299x3x473m6r">
            <ul className="flex flex-wrap gap-2.5" data-id="element-118" data-mp="27p2y8lsm59f">
              {skills.map(skill => <li key={skill} data-id="element-119" data-mp="3tgcpgrvrryik">
                  <span className="inline-block cursor-default border border-steel-200 px-4 py-2.5 text-sm font-medium text-navy-700 transition-colors duration-150 ease-exec hover:border-bronze hover:bg-canvas" data-id="element-120" data-mp="3theddwxvwfhp">
                    {skill}
                  </span>
                </li>)}
            </ul>

            <div className="mt-10 border-l-2 border-bronze pl-6" data-id="element-121" data-mp="22jtmom4ctfhn">
              <p className="font-serif text-lg leading-relaxed text-navy" data-id="element-122" data-mp="22kborzdp6nxh">
                Board of Directors member, Austin Commercial (2014–2026), with
                joint-venture steering experience across Clark Construction, Hunt
                Construction, and Morse Diesel partnerships.
              </p>
              <p className="mt-3 text-sm text-steel-400" data-id="element-123" data-mp="2hezsb7zjfcag">
                Available for corporate, nonprofit, and advisory board
                appointments in construction, real estate, and infrastructure.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}